import { render, staticRenderFns } from "./SubmittedApplicationList.vue?vue&type=template&id=15480fb9&lang=html&"
import script from "./SubmittedApplicationList.vue?vue&type=script&lang=js&"
export * from "./SubmittedApplicationList.vue?vue&type=script&lang=js&"
import style0 from "./SubmittedApplicationList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports